export const camposFormulario = (tipos = []) => {
    return {
        title: "Pokémon",
        campos: [
            { name: "pokeNombre", label: "Nombre", type: "text" },
            { name: "pokeNumeroPokedex", label: "N° Pokédex", type: "number" },
            { name: "pokeCodigo", label: "Código", type: "text" },
            { name: "pokePoderCalculado", label: "Poder Calculado", type: "number" },
        ]
    }
}

export const camposFormularioCrear = ({ tiposPrincipal = [], tiposSecundario = [], preevoluciones = [], pokemonesOriginales = [] } = {}) => {
    // Normaliza las opciones si vienen en formato de API (con .datos)
    const normalize = (arr) => Array.isArray(arr?.datos) ? arr.datos : arr;
    return {
        title: "Agregar Pokémon",
        campos: [
            { name: "poke_nombre", label: "Nombre", type: "text", rules: [{ required: true }] },
            { name: "poke_nombre_sprite", label: "Nombre Sprite", type: "text", rules: [] },
            { name: "poke_ataque", label: "Ataque", type: "number", rules: [{ required: true }] },
            { name: "poke_vida", label: "Vida", type: "number", rules: [{ required: true }] },
            { name: "poke_velocidad", label: "Velocidad", type: "number", rules: [{ required: true }] },
            { name: "poke_numero_pokedex", label: "N° Pokédex", type: "number", rules: [{ required: true }] },
            { name: "poke_codigo", label: "Código", type: "text", rules: [{ required: true }] },
            { name: "poke_poder_calculado", label: "Poder Calculado", type: "number", rules: [{ required: true }] },
            { name: "tipo_principal", label: "Tipo Principal", type: "select", opciones: normalize(tiposPrincipal), rules: [{ required: true }] },
            { name: "tipo_secundario", label: "Tipo Secundario", type: "select", opciones: normalize(tiposSecundario) },
            { name: "preevolucion_id", label: "Preevolución", type: "select", opciones: normalize(preevoluciones) },
            { name: "pokemon_original", label: "Pokémon Original", type: "select", opciones: normalize(pokemonesOriginales) },
            { name: "depo_descripcion", label: "Descripción", type: "text", rules: [{ required: true }] },
            { name: "depo_altura", label: "Altura", type: "text", rules: [{ required: true }] },
            { name: "depo_peso", label: "Peso", type: "text", rules: [{ required: true }] },
            { name: "depo_seudonimo", label: "Seudónimo", type: "text", rules: [{ required: true }] },
        ]
    }
}

export const columns = (moveTab = null) => [
    {
        title: "Nombre",
        dataIndex: "poke_nombre",
        width: "30%",
        render: (text, record) => moveTab ? (
            <a onClick={() => moveTab(record)} style={{ cursor: 'pointer' }}>{text}</a>
        ) : text
    },
    { title: "N° Pokédex", dataIndex: "poke_numero_pokedex", width: "20%" },
    { title: "Código", dataIndex: "poke_codigo", width: "20%" },
    { title: "Poder Calculado", dataIndex: "poke_poder_calculado", width: "30%" },
];
